import ApiService from "@/common/api.service";

export const CpdActivityCategoryService = {
  create(params) {
    return ApiService.post("category/add", params);
  },
  update(slug, params) {
    return ApiService.update("category", slug, params);
  },
};

